



























































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'

settings =
  name: "VariableSetEditor"

  vue:
    props: ['variableSet', 'defaults', 'actions']
    components: { LoadingIndicator }

    data: ->
      variableBeingEdited: ''
      showAll: false

    computed:
      variables: ->
        vars = @variableSettings
        vars[name] = value for name, value of @variableSet
        vars

      variableSettings: -> @defaults || @variableSet || {}
      variablesCount: -> Object.values(@variableSet).length

    methods:
      variableIsOverridden: (name) -> @variableSet[name]?
      showVariable: (name) -> @showAll || @variableIsOverridden(name)

      hiEnableEditMode: (variable) -> @variableBeingEdited = variable
      hiDisableEditMode: -> @variableBeingEdited = ''

      hiSetVariable: (name) ->
        @actions.setVariable(name, @variableSet[name])
        @hiDisableEditMode()

      hiClearVariable: (name) ->
        @actions.setVariable(name, null)
        @hiDisableEditMode()

export default VueOptions.vue settings
